module.exports = __webpack_public_path__ + "img/carrousel-mamo-8.a8380f10.png";